/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

import {
  OnboardingPromptStatus,
  type OnboardingPlatform,
  type OnboardingPromptResponse,
  type OnboardingEventNameType,
} from "./types";

import type { PayloadAction } from "@reduxjs/toolkit";

export const filterOnboardingPrompts = (
  platform: OnboardingPlatform,
  prompts: OnboardingPromptResponse["prompts"],
  eventNameBlacklist: OnboardingEventNameType[] = [],
) =>
  prompts
    .filter(
      (item) =>
        item.platforms.includes(platform) &&
        !eventNameBlacklist.includes(item.event_name),
    )
    .map((item) => {
      const updatedItem = { ...item };
      if (item.status === OnboardingPromptStatus.completed) {
        updatedItem.icon_name = "check";
      }
      return updatedItem;
    });

const name = "onboarding";

type OnboardingSliceState = OnboardingPromptResponse & {
  eventNameBlacklist: OnboardingEventNameType[];
};

const initialState: OnboardingSliceState = {
  id: "",
  title: "",
  description: "",
  guide_type: "onboarding",
  platforms: [],
  prompts: [],
  eventNameBlacklist: [],
};

type UpsertOnboardingPrompts = {
  platform: OnboardingPlatform;
  eventNameBlacklist?: OnboardingEventNameType[];
} & OnboardingPromptResponse;

const slice = createSlice({
  name,
  initialState,
  reducers: {
    upsert: (state, action: PayloadAction<UpsertOnboardingPrompts>) => {
      const {
        payload: {
          id,
          title,
          description,
          guide_type,
          platforms,
          prompts,
          platform: currentPlatform,
        },
      } = action;
      const filteredPrompts = filterOnboardingPrompts(currentPlatform, prompts);

      state.id = id;
      state.title = title;
      state.description = description;
      state.guide_type = guide_type;
      state.platforms = platforms;
      state.prompts = filteredPrompts;
    },
    setBlacklist: (
      state,
      action: PayloadAction<{ eventNameBlacklist: OnboardingEventNameType[] }>,
    ) => {
      const {
        payload: { eventNameBlacklist = [] },
      } = action;

      state.eventNameBlacklist = eventNameBlacklist;
    },
    clearAll: () => {
      return { ...initialState };
    },
  },
});

export const { actions } = slice;

export default {
  [name]: slice.reducer,
};
